import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';
import { $ } from 'protractor';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() question: QuestionBase<any>;
  @Input() iconColor: string = "";
  @Input() readonly = false;
  @Output() selected = new EventEmitter<boolean>();
  allowChecked = true;

  ngOnInit(): void {    
  }

  check(value1, value2) {
    return Number(value1) === Number(value2);
  }

  handleClick(event, key) {
    if (this.readonly) {
      event.preventDefault();
      return;
    }
    let value;
    this.allowChecked = true;
    value = event.target.value;

    this.form.controls[key].setValue(value);
    this.selected.emit(true);
    this.form.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/radio/radio.component.ts